module.exports = __webpack_public_path__ + "img/malfunction-indicator-on.3d0a2d86.svg";